<template>
	<div class="container-analytics">
		<div class="container-squares-charts">
			<squarechart
				class="square-container"
				:series="totalSaves"
				pack="mdi"
				icon="save"
				:title="`Pedidos Salvos`"
				:subtitle="totalSaves[0].count"
				color="#f79824"
				:cuntinterval="totalSales[0].interval"
			/>
			<Realtime
				class="square-container"
				:series="graphics"
				pack="mdi"
				icon="eye"
				:title="`Usuários Ativos`"
				:subtitle="activeUsers"
				color="#d62828"
				:cuntinterval="realtimeInterval"
				@reset-data="realtimeData = [0, 0, 0, 0, 0]"
			/>

			<squarechart
				class="square-container"
				:series="newUsers"
				pack="mdi"
				icon="users"
				:title="`Novos Usuários`"
				:subtitle="newUsers[0].count"
				color="#22cc22"
				:cuntinterval="totalSales[0].interval"
			/>

			<squarechart
				class="square-container"
				:series="totalSales"
				pack="mdi"
				icon="shopping-cart"
				:title="`Total de Vendas`"
				:subtitle="totalSales[0].count"
				color="#2d00f7"
				:cuntinterval="totalSales[0].interval"
			/>
		</div>
		<div class="second-session">
			<div class="chart-custom">
				<div class="nav-chart-top">
					<h1>Cadastro de Clientes</h1>
					<b-dropdown v-model="interval" aria-role="list">
						<button slot="trigger" slot-scope="{ active }" class="button">
							<span class="device-days">{{
								interval == 1
									? 'Últimas 24 Horas'
									: interval == 7
									? 'Últimos 7 dias'
									: 'Últimos 30 dias'
							}}</span>
							<b-icon :icon="active ? 'menu-up' : 'menu-down'" />
						</button>
						<b-dropdown-item :value="1" aria-role="listitem"> Últimas 24 horas </b-dropdown-item>
						<b-dropdown-item :value="7" aria-role="listitem"> Últimos 7 dias </b-dropdown-item>
						<b-dropdown-item :value="30" aria-role="listitem"> Últimos 30 dias </b-dropdown-item>
					</b-dropdown>
				</div>
				<div class="chart-description">
					<div class="legend-chart">
						<h1 class="receberam">Receberam Link</h1>
						<h1 class="nConcretizaram">Cadastros não Concretizados</h1>
						<h1 class="cadastrados">Cadastrados</h1>
					</div>
				</div>
				<Tree :series="series" :interval="intervaltree" />
			</div>
			<devices
				vuewidth="23%"
				icon="shopping-cart"
				:title="`Total de Vendas`"
				color="#2d00f7"
				:description-date="descriptionDate"
				:data="devicesData.devices.dataCharts"
				:devices-label="devicesLabel"
				@change="getDevicesInfo($event)"
			/>
		</div>
		<div class="tree-session">
			<div class="map-container">
				<kMap :data="mapData" />
				<div class="box-map">
					<div
						v-for="(state, index) of mapData"
						:key="index"
						:class="`map-label ${state.active === 0 ? 'inactive' : null}`"
					>
						<div v-if="state.active > 0" class="box-states">
							<span class="state-label">{{ state.nome }}</span>
							<span class="number-label">{{ state.active }}</span>
						</div>
					</div>
				</div>
			</div>
			<div class="rectangle-chart">
				<div class="box-rectangle">
					<div class="title-rectangle">
						<h1 class="titulo-pedidos-chart">Pedidos</h1>
						<div class="box-labels">
							<div class="label-chart-rectangle">
								<kCircle
									:styles="{
										backgroundColor: '#f79824',
										width: '10px',
										height: '10px',
										display: 'flex',
										borderRadius: '50%',
										marginRight: '7px',
									}"
								/>
								<p>Salvo</p>
							</div>
							<div class="label-chart-rectangle">
								<kCircle
									:styles="{
										backgroundColor: '#2d00f7',
										width: '10px',
										height: '10px',
										display: 'flex',
										borderRadius: '50%',
										marginRight: '7px',
									}"
								/>
								<p>Finalizado</p>
							</div>
							<div class="label-chart-rectangle">
								<kCircle
									:styles="{
										backgroundColor: '#d62828',
										width: '10px',
										height: '10px',
										display: 'flex',
										borderRadius: '50%',
										marginRight: '7px',
									}"
								/>
								<p>Cancelado</p>
							</div>
						</div>
					</div>
					<Rectangle
						:interval="intervalPedidosAnalytics"
						:data="dataPedidosAnalytics"
						width="100%"
						height="100%"
						padding="0"
					/>
				</div>
				<div class="container-valor">
					<div class="title-filtro">
						<div>
							<select v-model="selectValor" class="select-custom">
								<option :value="1">1 dia atrás</option>
								<option :value="7">7 dias atrás</option>
								<option :value="30">Um més atrás</option>
								<option :value="6">6 meses atrás</option>
								<option :value="12">1 ano atrás</option>
							</select>
							<!--   <kfilter
                :filter-visibility="filterVisibility"
                @open-filter="filterVisibility = true"
                @clear="clearFilter"
                @apply="(filterVisibility = !filterVisibility), filter()"
              >
                <template v-slot:container>
                  <div class="container-filter">
                    <div class="situation-box">
                      <b-checkbox v-model="datapagamentocheck" size="is-small" class="checkbox-situation">
                        Data do Pedido
                      </b-checkbox>
                      <div v-if="datapagamentocheck" class="situation-box-input">
                        <feather type="corner-down-right" size="18" class="arrow-indicator" />
                        <div class="grouped-situation-input">
                          <b-input
                            v-model="pedidoInput[0]"
                            type="date"
                            size="is-small"
                            class="input-date-picker"
                          />
                          <b-input
                            v-model="pedidoInput[1]"
                            type="date"
                            size="is-small"
                            class="input-date-picker"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </kfilter> -->
						</div>
					</div>
					<div class="box-pedidos-filtros">
						<div class="total-finalizados">
							<k-icon
								:icon="{
									type: 'flag',
									size: '16px',
									color: '#2d00f7',
									width: '40px',
									height: '40px',
									borderRadius: '50%',
								}"
							/>
							<div class="text-margin">
								<span class="total-valor">{{
									transformToBrl(dataPedidosAnalytics[1].total_value)
								}}</span>
								<h1>Finalizados</h1>
							</div>
						</div>
						<div class="total-finalizados">
							<k-icon
								:icon="{
									type: 'x',
									size: '16px',
									color: '#d62828',
									width: '40px',
									height: '40px',
									borderRadius: '50%',
								}"
							/>
							<div class="text-margin">
								<span class="total-valor">{{
									transformToBrl(dataPedidosAnalytics[2].total_value)
								}}</span>
								<h1>Cancelado</h1>
							</div>
						</div>
						<div class="total-finalizados">
							<k-icon
								:icon="{
									type: 'save',
									size: '16px',
									color: '#f79824',
									width: '40px',
									height: '40px',
									borderRadius: '50%',
								}"
							/>
							<div class="text-margin">
								<span class="total-valor">{{
									transformToBrl(dataPedidosAnalytics[0].total_value)
								}}</span>
								<h1>Salvo</h1>
							</div>
						</div>
						<div class="last-updated">
							<span class="title">Ultima Atualização</span>
							<span class="text">{{
								lastUpdatedOrdersValues ? lastUpdatedOrdersValues : 'Atualizando...'
							}}</span>
						</div>
					</div>
				</div>
			</div>
			<div class="two-blocks">
				<div id="card">
					<Analytics
						:series="sessionPerUser"
						:title="`Sessões por Usuário`"
						:date-interval="dateIntervalSessionPerUser"
						@change="getSessionsPerUser($event)"
						@change-date="getSessionsPerUser"
					/>
				</div>

				<div id="card">
					<Analytics
						:series="newUsersStats"
						:title="`Novos Usuários`"
						:date-interval="dateIntervalNewUsers"
						@change="getNewUsers($event)"
						@change-date="getNewUsers"
					/>
				</div>
			</div>
		</div>

		<div class="fourth-session">
			<div id="first-block">
				<div id="card">
					<Analytics
						:series="totalUsersStats"
						:title="`Total de Usuários`"
						:date-interval="dateIntervalTotalUsers"
						@change="getTotalUsers($event)"
						@change-date="getTotalUsers"
					/>
				</div>

				<div id="card">
					<Analytics
						:series="sessionsStats"
						:title="`Média de Sessões`"
						:date-interval="dateIntervalSessions"
						@change="getSessions($event)"
						@change-date="getSessions"
					/>
				</div>

				<div id="card">
					<Analytics
						:series="bounceRateStats"
						:title="`Taxa de Rejeição`"
						:formated="`percent`"
						:date-interval="this.dateIntervalBounceRate"
						@change="getBounceRate($event)"
						@change-date="getBounceRate($event)"
					/>
				</div>
			</div>

			<div id="second-block">
				<div id="card">
					<Analytics
						:series="avgSessionDurationStats"
						:title="`Duração Média de Sessão`"
						:formated="`time`"
						:date-interval="dateIntervalAvgSessionDuration"
						@change="getAvgSessionDuration($event)"
						@change-date="getAvgSessionDuration"
					/>
				</div>

				<div id="card">
					<Analytics
						:series="screenViewsPerPageStats"
						:title="`Visualizações de Páginas`"
						:date-interval="dateIntervalScreenViewsPerPage"
						@change="getScreenViewsPerPage($event)"
						@change-date="getScreenViewsPerPage"
					/>
				</div>

				<div id="card">
					<ChartTypeUser
						:total="pieTotals"
						:series="userTypeStats"
						:title="`Tipo de visitantes`"
						@change="getVisitorsType($event)"
						@change-date="getVisitorsType"
					/>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
// eslint-disable-next-line no-param-reassign
import moment from 'moment';
import 'moment/locale/pt-br';
import squarechart from '../../../layout/components/charts/square';
import Realtime from '../../../layout/components/charts/realtime';
import devices from '../../../layout/components/charts/devices';
import Tree from '../../../layout/components/charts/tree';
import * as ecAxios from '../../../util/ecAxios';
import kMap from '../../../layout/components/charts/map';
import Rectangle from '../../../layout/components/charts/rectangle';
import global from '../../../mixins/global';
import kIcon from '../../../layout/components/miscellaneous/icon-circle';
import kCircle from '../../../layout/components/miscellaneous/circle';
import Analytics from '../../../layout/components/charts/analytics';
import ChartTypeUser from '../../../layout/components/charts/typeUser';
/* import kfilter from '../../../layout/components/filter/custom';
 */
export default {
	name: 'Home',
	components: {
		Tree,
		kCircle,
		kIcon,
		squarechart,
		Analytics,
		devices,
		Rectangle,
		Realtime,
		kMap,
		ChartTypeUser,
		/*  kfilter, */
	},
	mixins: [global],
	data() {
		return {
			lastUpdatedOrdersValues: null,
			selectValor: 1,
			filterVisibility: false,
			datapagamentocheck: true,
			intervalPedidosAnalytics: ['00/00', '00/00', '00/00', '00/00', '00/00'],
			pieTotals: 0,
			dataPedidosAnalytics: [
				{
					name: 'Cancelados',
					data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
				},
				{
					name: 'Finalizados',
					data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
				},
				{
					name: 'Salvos',
					data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
				},
			],
			clearFilter: {},
			cuntinterval: [],
			dtFinal: moment().format('YYYY-MM-DD'),
			dtInicial: moment(this.dtFinal).format('YYYY-MM-DD'),
			timeout: 'full',
			interval: 1,
			activeUsers: 0,
			pedidoInput: [null, null],
			mapData: [
				{
					id: 11,
					sigla: 'RO',
					active: 0,
					nome: 'Rondônia',
					regiao: {
						id: 1,
						sigla: 'N',
						nome: 'Norte',
					},
				},
				{
					id: 12,
					sigla: 'AC',
					active: 0,
					nome: 'Acre',
					regiao: {
						id: 1,
						sigla: 'N',
						nome: 'Norte',
					},
				},
				{
					id: 13,
					sigla: 'AM',
					active: 0,
					nome: 'Amazonas',
					regiao: {
						id: 1,
						sigla: 'N',
						nome: 'Norte',
					},
				},
				{
					id: 14,
					sigla: 'RR',
					active: 0,
					nome: 'Roraima',
					regiao: {
						id: 1,
						sigla: 'N',
						nome: 'Norte',
					},
				},
				{
					id: 15,
					sigla: 'PA',
					active: 0,
					nome: 'Pará',
					regiao: {
						id: 1,
						sigla: 'N',
						nome: 'Norte',
					},
				},
				{
					id: 16,
					sigla: 'AP',
					active: 0,
					nome: 'Amapá',
					regiao: {
						id: 1,
						sigla: 'N',
						nome: 'Norte',
					},
				},
				{
					id: 17,
					sigla: 'TO',
					active: 0,
					nome: 'Tocantins',
					regiao: {
						id: 1,
						sigla: 'N',
						nome: 'Norte',
					},
				},
				{
					id: 21,
					sigla: 'MA',
					active: 0,
					nome: 'Maranhão',
					regiao: {
						id: 2,
						sigla: 'NE',
						nome: 'Nordeste',
					},
				},
				{
					id: 22,
					sigla: 'PI',
					active: 0,
					nome: 'Piauí',
					regiao: {
						id: 2,
						sigla: 'NE',
						nome: 'Nordeste',
					},
				},
				{
					id: 23,
					sigla: 'CE',
					active: 0,
					nome: 'Ceará',
					regiao: {
						id: 2,
						sigla: 'NE',
						nome: 'Nordeste',
					},
				},
				{
					id: 24,
					sigla: 'RN',
					active: 0,
					nome: 'Rio Grande do Norte',
					regiao: {
						id: 2,
						sigla: 'NE',
						nome: 'Nordeste',
					},
				},
				{
					id: 25,
					sigla: 'PB',
					active: 0,
					nome: 'Paraíba',
					regiao: {
						id: 2,
						sigla: 'NE',
						nome: 'Nordeste',
					},
				},
				{
					id: 26,
					sigla: 'PE',
					active: 0,
					nome: 'Pernambuco',
					regiao: {
						id: 2,
						sigla: 'NE',
						nome: 'Nordeste',
					},
				},
				{
					id: 27,
					sigla: 'AL',
					active: 0,
					nome: 'Alagoas',
					regiao: {
						id: 2,
						sigla: 'NE',
						nome: 'Nordeste',
					},
				},
				{
					id: 28,
					sigla: 'SE',
					active: 0,
					nome: 'Sergipe',
					regiao: {
						id: 2,
						sigla: 'NE',
						nome: 'Nordeste',
					},
				},
				{
					id: 29,
					sigla: 'BA',
					active: 0,
					nome: 'Bahia',
					regiao: {
						id: 2,
						sigla: 'NE',
						nome: 'Nordeste',
					},
				},
				{
					id: 31,
					sigla: 'MG',
					active: 0,
					nome: 'Minas Gerais',
					regiao: {
						id: 3,
						sigla: 'SE',
						nome: 'Sudeste',
					},
				},
				{
					id: 32,
					sigla: 'ES',
					active: 0,
					nome: 'Espírito Santo',
					regiao: {
						id: 3,
						sigla: 'SE',
						nome: 'Sudeste',
					},
				},
				{
					id: 33,
					sigla: 'RJ',
					active: 0,
					nome: 'Rio de Janeiro',
					regiao: {
						id: 3,
						sigla: 'SE',
						nome: 'Sudeste',
					},
				},
				{
					id: 35,
					sigla: 'SP',
					active: 0,
					nome: 'São Paulo',
					regiao: {
						id: 3,
						sigla: 'SE',
						nome: 'Sudeste',
					},
				},
				{
					id: 41,
					sigla: 'PR',
					active: 0,
					nome: 'Paraná',
					regiao: {
						id: 4,
						sigla: 'S',
						nome: 'Sul',
					},
				},
				{
					id: 42,
					sigla: 'SC',
					active: 0,
					nome: 'Santa Catarina',
					regiao: {
						id: 4,
						sigla: 'S',
						nome: 'Sul',
					},
				},
				{
					id: 43,
					sigla: 'RS',
					active: 0,
					nome: 'Rio Grande do Sul',
					regiao: {
						id: 4,
						sigla: 'S',
						nome: 'Sul',
					},
				},
				{
					id: 50,
					sigla: 'MS',
					active: 0,
					nome: 'Mato Grosso do Sul',
					regiao: {
						id: 5,
						sigla: 'CO',
						nome: 'Centro-Oeste',
					},
				},
				{
					id: 51,
					sigla: 'MT',
					active: 0,
					nome: 'Mato Grosso',
					regiao: {
						id: 5,
						sigla: 'CO',
						nome: 'Centro-Oeste',
					},
				},
				{
					id: 52,
					sigla: 'GO',
					active: 0,
					nome: 'Goiás',
					regiao: {
						id: 5,
						sigla: 'CO',
						nome: 'Centro-Oeste',
					},
				},
				{
					id: 53,
					sigla: 'DF',
					active: 0,
					nome: 'Distrito Federal',
					regiao: {
						id: 5,
						sigla: 'CO',
						nome: 'Centro-Oeste',
					},
				},
			],
			intervaltree: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
			devicesData: {
				devices: {
					dataCharts: [0, 0, 0],
				},
				desktop: {
					previousPeriod: 0,
					searchedRange: 0,
					variation: 0,
					porcentagemCategoria: 0,
					porcentagem: 0,
				},
				mobile: {
					previousPeriod: 0,
					searchedRange: 0,
					variation: 0,
					porcentagemCategoria: 0,
					porcentagem: 0,
				},
				tablet: {
					previousPeriod: 0,
					searchedRange: 0,
					variation: 0,
					porcentagemCategoria: 0,
					porcentagem: 0,
				},
				error: 0,
				interval: {
					previousPeriod: {
						startDate: 0,
						endDate: 0,
					},
					searchedRange: {
						startDate: 0,
						endDate: 0,
					},
				},
				maximus: {
					previousPeriod: 0,
					searchedRange: 0,
				},
				minimus: {
					previousPeriod: 0,
					searchedRange: 0,
				},
			},
			notregistered: {
				name: 'Cadastros não Concretizados',
				data: [0, 0, 0, 0, 0, 0, 0],
			},
			registered: {
				name: 'Cadastros',
				data: [0, 0, 0, 0, 0, 0, 0],
			},

			pending: {
				name: 'Receberam Link',
				data: [0, 0, 0, 0, 0, 0, 0],
			},
			totalSaves: [
				{
					name: 'Pedidos Salvos',
					data: [0, 0, 0, 0, 0, 0, 0],
				},
			],
			newUsers: [
				{
					name: 'Usuários',
					data: [0, 0, 0, 0, 0, 0, 0],
				},
			],
			totalSales: [
				{
					name: 'Vendas',
					data: [0, 0, 0, 0, 0, 0, 0],
				},
			],
			tableheader: [
				{
					id: 121,
					label: 'ID',
				},
				{
					id: 122,
					label: 'Fornecedor',
				},
				{
					id: 123,
					label: 'Data',
				},
				{
					id: 124,
					label: 'Valor',
				},
			],
			sales: [
				{
					id: 121,
					fornecedor: 'Dpc Distribuidora Atacadista',
					data: '26/05/2020',
					valor: 'R$ 20.000,00',
				},
			],
			selected: null,
			data: [23, 21, 33],
			devicesLabel: ['Desktop', 'Smartphone', 'Tablet'],
			descriptionDate: [
				{
					id: 212,
					nome: 'Desktop',
					nomeicon: 'monitor',
					icone: 'arrow-up',
					color: '#7159c1',
					variation: 0,
					porcentagemCategoria: 0,
					porcentagem: 0,
				},
				{
					id: 213,
					nome: 'Smartphone',
					nomeicon: 'smartphone',
					icone: 'arrow-up',
					color: '#7159c1',
					variation: 0,
					porcentagemCategoria: 0,
					porcentagem: 0,
				},
				{
					id: 214,
					nome: 'Tablet',
					nomeicon: 'tablet',
					icone: 'arrow-up',
					color: '#7159c1',
					variation: 0,
					porcentagemCategoria: 0,
					porcentagem: 0,
				},
			],
			realtimeData: [0],
			realtimeInterval: [moment().add(3, 'hours').format('DD-MM-YYYY hh:mm:ss')],
			sessionPerUser: [],
			newUsersStats: [],
			totalUsersStats: [],
			userTypeStats: [],
			sessionsStats: [],
			bounceRateStats: [],
			avgSessionDurationStats: [],
			screenViewsPerPageStats: [],
			dateInterval: 1,
			dateIntervalBounceRate: 1,
			dateIntervalSessionPerUser: 1,
			dateIntervalNewUsers: 1,
			dateIntervalTotalUsers: 1,
			dateIntervalSessions: 1,
			dateIntervalAvgSessionDuration: 1,
			dateIntervalScreenViewsPerPage: 1,
		};
	},
	computed: {
		getGlobalDate() {
			return this.$store.getters.getGlobalRangeDate;
		},
		selectedString() {
			return this.selected ? this.selected.toDateString() : '';
		},
		graphics() {
			return [
				{
					name: 'Usuários Ativos',
					data: this.realtimeData,
				},
			];
		},
		series() {
			return [this.registered, this.pending, this.notregistered];
		},
	},
	watch: {
		selectValor(e) {
			let interval = null;
			switch (e) {
				case 1:
					interval = this.createInterval({
						interval: e,
						date: moment().subtract(e, 'days').format('YYYY-MM-DD 00:00:00'),
					});
					break;
				case 7:
					interval = this.createInterval({
						interval: e,
						date: moment().subtract(e, 'days').format('YYYY-MM-DD'),
					});
					break;
				case 30:
					interval = this.createInterval({
						interval: e,
						date: moment().subtract(e, 'days').format('YYYY-MM-DD'),
					});
					break;
				case 6:
					interval = this.createInterval({
						interval: e,
						date: moment().subtract(e, 'months').format('YYYY-MM-DD'),
					});
					break;
				case 12:
					interval = this.createInterval({
						interval: e,
						date: moment().subtract(e, 'months').format('YYYY-MM-DD'),
					});
					break;
				default:
					break;
			}
			this.getAnalyticsPedidos({
				situacao: [0, 1, 7],
				interval,
				days: this.selectValor,
			});
		},
		getGlobalDate() {
			this.dtInicial = moment(this.$store.getters.getGlobalRangeDate[0]).format('YYYY-MM-DD');
			this.dtFinal = moment(this.$store.getters.getGlobalRangeDate[1]).format('YYYY-MM-DD');
			const diff = moment(this.dtInicial).diff(moment(this.dtFinal), 'milliseconds');
			const duration = moment.duration(diff);
			// eslint-disable-next-line no-underscore-dangle
			// eslint-disable-next-line no-underscore-dangle
			this.interval = Math.abs(duration._data.days) === 0 ? 1 : Math.abs(duration._data.days);
		},
		interval() {
			this.getRegistration();
			/*  this.getData(); */
		},
	},
	created() {
		this.getSessionsPerUser();
		this.getNewUsers();
		this.getTotalUsers();
		this.getSessions();
		this.getBounceRate();
		this.getAvgSessionDuration();
		this.getScreenViewsPerPage();
		this.getVisitorsType();

		this.getData();
		this.getRegistration();
		this.getDevicesInfo(1);
		this.getActiveUsers();
		this.getSessionsByUf();
		this.getAnalyticsPedidos({
			situacao: [0, 1, 7],
			interval: this.createInterval({
				interval: this.selectValor,
				date: moment().subtract(this.selectValor, 'days').format('YYYY-MM-DD 00:00:00'),
			}),
			days: this.selectValor,
		});
	},

	methods: {
		getMaxOfArray(numArray) {
			return Math.max.apply(null, numArray);
		},
		getMinOfArray(numArray) {
			return Math.min.apply(null, numArray);
		},
		/*     filter() {
	  if (this.datapagamentocheck && this.pedidoInput[0] && this.pedidoInput[1]) {
		this.getAnalyticsPedidos({
		  situacao: [0, 1, 7],
		  interval: {
			from: this.pedidoInput[0],
			to: this.pedidoInput[1]
		  }
		});
	  }
	}, */
		createInterval(params) {
			const interval = [];
			switch (params.interval) {
				case 1:
					// eslint-disable-next-line no-plusplus
					for (let index = 1; index <= 24; index++) {
						const startOf = moment(params.date).add(index - 1, 'hours');
						const endOf = moment(params.date).add(index, 'hours');
						interval.push([
							startOf.format('YYYY-MM-DD HH:mm:ss'),
							endOf.format('YYYY-MM-DD HH:mm:ss'),
						]);
					}
					break;
				case 7:
					// eslint-disable-next-line no-plusplus
					for (let index = 1; index <= params.interval; index++) {
						const startOf = moment(params.date).add(index, 'days');
						const endOf = moment(params.date).add(index, 'days');
						interval.push([
							startOf.format('YYYY-MM-DD 00:00:00'),
							endOf.format('YYYY-MM-DD 23:59:59'),
						]);
					}
					break;
				case 30:
					// eslint-disable-next-line no-plusplus
					for (let index = 1; index <= params.interval; index++) {
						const startOf = moment(params.date).add(index, 'days');
						const endOf = moment(params.date).add(index, 'days');
						interval.push([
							startOf.format('YYYY-MM-DD 00:00:00'),
							endOf.format('YYYY-MM-DD 23:59:59'),
						]);
					}
					break;
				case 6:
					// eslint-disable-next-line no-plusplus
					for (let index = 1; index <= params.interval; index++) {
						const startOf = moment(params.date).add(index, 'months');
						const endOf = moment(params.date).add(index, 'months');
						interval.push([
							startOf.startOf('month').format('YYYY-MM-DD 00:00:00'),
							endOf.endOf('month').format('YYYY-MM-DD 23:59:59'),
						]);
					}
					break;
				case 12:
					// eslint-disable-next-line no-plusplus
					for (let index = 1; index <= params.interval; index++) {
						const startOf = moment(params.date).add(index, 'months');
						const endOf = moment(params.date).add(index, 'months');
						interval.push([
							startOf.startOf('month').format('YYYY-MM-DD 00:00:00'),
							endOf.endOf('month').format('YYYY-MM-DD 23:59:59'),
						]);
					}
					break;
				default:
					break;
			}
			return interval;
		},
		async getRegistration() {
			await ecAxios
				.connection()
				.post(`${process.env.VUE_APP_API_ADM_EC}${api.env.TOTAL_USERS_REGISTERED}`, {
					dt_inicial: `${this.dtInicial} 00:00:01`,
					dt_final: `${this.dtFinal} 23:59:59`,
					interval: this.interval,
					novasenha: 1,
				})
				.then((response) => {
					if (response.status === 200) {
						this.registered = response.data;
					}
				})
				.catch(() => {
					this.registered = {
						name: 'Cadastros',
						data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
					};
				});

			await ecAxios
				.connection()
				.post(`${process.env.VUE_APP_API_ADM_EC}${api.env.TOTAL_USERS_PENDING}`, {
					dt_inicial: this.dtInicial,
					dt_final: this.dtFinal,
					interval: this.interval,
					status: [1],
					novasenha: [0],
				})
				.then((response) => {
					if (response.status === 200) {
						this.pending = response.data;
						this.intervaltree = this.pending.interval;
					}
				})
				.catch(() => {
					this.pending = {
						name: 'Receberam Link',
						data: [0, 0, 0, 0, 0, 0, 0],
					};
				});

			await ecAxios
				.connection()
				.post(`${process.env.VUE_APP_API_ADM_EC}${api.env.TOTAL_USERS_NOTREGISTERED}`, {
					dt_inicial: this.dtInicial,
					dt_final: this.dtFinal,
					interval: this.interval,
					status: [0],
					novasenha: [0],
				})
				.then((response) => {
					if (response.status === 200) {
						this.notregistered = response.data;
					}
				})
				.catch(() => {
					this.notregistered = {
						name: 'Cadastros não Concretizados',
						data: [0, 0, 0, 0, 0, 0, 0],
					};
				});
			this.timeout = setTimeout(() => {
				this.getRegistration();
			}, 60000);
		},
		async getActiveUsers() {
			const url = `${process.env.VUE_APP_API_ADM_EC + api.env.ACTIVE_USERS}`;
			const request = await ecAxios.connection().post(`${url}`);

			const { realtime } = request.data;
			this.activeUsers = realtime.activeUsers;
			this.realtimeInterval.push(moment(realtime.dateTime).format('DD-MM-YYYY hh:mm:ss'));
			this.realtimeData.push(realtime.activeUsers);
			this.timeout = setTimeout(() => {
				this.getActiveUsers();
			}, 60000);
		},
		async getAnalyticsPedidos(params = null) {
			this.lastUpdatedOrdersValues = null;
			try {
				const url = `${process.env.VUE_APP_API_ADM_EC + api.env.ORDERS_ANALYTICS}`;
				const request = await ecAxios.connection().post(url, params);
				const { pedidos, error, updatedAt } = request.data;
				if (error === 0) {
					this.dataPedidosAnalytics = pedidos;
					this.intervalPedidosAnalytics = pedidos[0].invervalo;
					this.lastUpdatedOrdersValues = updatedAt;
				} else {
					throw new Error('Erro ao atualizar');
				}
			} catch (error) {
				// eslint-disable-next-line no-console
				console.error(error);
				this.lastUpdatedOrdersValues = 'Erro ao atualizar';
			}
		},
		async getSessionsByUf() {
			const url = `${process.env.VUE_APP_API_ADM_EC + api.env.ACTIVE_USERS_UF}`;
			const request = await ecAxios.connection().post(`${url}`);
			const { data } = request;
			this.mapData = data;
			this.timeout = setTimeout(() => {
				this.getSessionsByUf();
			}, 60000);
		},
		async getDevicesInfo(days = 1) {
			try {
				const params = {
					days,
				};
				const url = `${process.env.VUE_APP_API_ADM_EC + api.env.DEVICES_CATEGORY}`;
				const request = await ecAxios.connection().post(`${url}`, params);

				const { data } = request;

				if (data.error !== 1) {
					this.devicesData = data;
					this.descriptionDate = [
						{
							id: 212,
							nome: 'Desktop',
							nomeicon: 'monitor',
							icone:
								Math.sign(this.devicesData.devices.desktop.variation) !== -1
									? 'arrow-up'
									: 'arrow-down',
							color:
								Math.sign(this.devicesData.devices.desktop.variation) !== -1
									? '#28c76f'
									: '#ea5455',
							porcentagem: this.devicesData.devices.desktop.variation,
							porcentagemCategoria: this.devicesData.devices.desktop.percentCategory,
						},
						{
							id: 213,
							nome: 'Mobile',
							nomeicon: 'smartphone',
							icone:
								Math.sign(this.devicesData.devices.mobile.variation) !== -1
									? 'arrow-up'
									: 'arrow-down',
							color:
								Math.sign(this.devicesData.devices.mobile.variation) !== -1 ? '#28c76f' : '#ea5455',
							porcentagem: this.devicesData.devices.mobile.variation,
							porcentagemCategoria: this.devicesData.devices.mobile.percentCategory,
						},
						{
							id: 214,
							nome: 'Tablet',
							nomeicon: 'tablet',
							icone:
								Math.sign(this.devicesData.devices.tablet.variation) !== -1
									? 'arrow-up'
									: 'arrow-down',
							color:
								Math.sign(this.devicesData.devices.tablet.variation) !== -1 ? '#28c76f' : '#ea5455',
							porcentagem: this.devicesData.devices.tablet.variation,
							porcentagemCategoria: this.devicesData.devices.tablet.percentCategory,
						},
					];
				} else {
					// eslint-disable-next-line no-throw-literal
					throw { message: data.message };
				}
			} catch (e) {
				this.$buefy.notification.open({
					message: e.message || 'Erro ao buscar dados dos dispositivos',
					type: 'is-success',
				});
			}
		},
		async getData() {
			await ecAxios
				.connection()
				.post(`${process.env.VUE_APP_API_ADM_EC}${api.env.TOTAL_VENDAS}`, {
					situacoeslog: [
						{
							dtsituacao_fin: this.dtFinal,
							dtsituacao_ini: this.dtInicial,
							situacao: 1,
							dt_final: 1,
						},
					],
					interval: this.interval,
				})
				.then((response) => {
					if (response.status === 200) {
						this.totalSales = 0;
						this.totalSales = [response.data];
					}
				})
				.catch(() => {
					this.pedidos = [];
				});
			await ecAxios
				.connection()
				.post(`${process.env.VUE_APP_API_ADM_EC}${api.env.TOTAL_VENDAS}`, {
					interval: 1,
					title: 'Pedidos Salvo',
					situacoeslog: [
						{
							dtsituacao_fin: this.dtFinal,
							dtsituacao_ini: this.dtInicial,
							situacao: 0,
						},
					],
					situacao: 0,
				})
				.then((response) => {
					if (response.status === 200) {
						this.totalSaves = [response.data];
					}
				})
				.catch(() => {});

			await ecAxios
				.connection()
				.post(`${process.env.VUE_APP_API_ADM_EC}/analytics/users/new`, {
					newUser: this.dtFinal,
					interval: 1,
				})
				.then((response) => {
					if (response.status === 200) {
						this.newUsers = [response.data];
					}
				})
				.catch(() => {
					this.newUsers = [];
				});

			this.timeout = setTimeout(() => {
				this.getData();
			}, 60000);
		},

		async getSessionsPerUser(value) {
			await ecAxios
				.connection()
				.post(`${process.env.VUE_APP_API_ADM_EC}/analytics/stats/sessions-per-user`, {
					dataInicio:
						value === undefined ? moment().subtract(1, 'days').format('YYYY-MM-DD') : value,
					dataFim: 'today',
					dimension: '',
				})
				.then((res) => {
					res.data[1] = res.data[1].map((item) => item.slice(0, 4));
					res.data[2] = res.data[1].map((item) => `${item.slice(0, 5)}`);
					this.dateIntervalSessionPerUser = [res.data[0]];
					this.sessionPerUser = res.data;
				})
				.catch((error) => {
					console.log(error);
				});
		},

		async getNewUsers(value) {
			await ecAxios
				.connection()
				.post(`${process.env.VUE_APP_API_ADM_EC}/analytics/stats/new-users`, {
					dataInicio:
						value === undefined ? moment().subtract(1, 'days').format('YYYY-MM-DD') : value,
					dataFim: 'today',
					dimension: '',
				})
				.then((res) => {
					this.dateIntervalNewUsers = [res.data[0]];
					this.newUsersStats = res.data;
				})
				.catch((error) => {
					console.log(error);
				});
		},

		async getTotalUsers(value) {
			await ecAxios
				.connection()
				.post(`${process.env.VUE_APP_API_ADM_EC}/analytics/stats/total-users`, {
					dataInicio:
						value === undefined ? moment().subtract(1, 'days').format('YYYY-MM-DD') : value,
					dataFim: 'today',
					dimension: 'ga:date',
				})
				.then((res) => {
					const [date, totalsStats_, pieTotals] = res.data;
					this.totalUsersStats = res.data;
					this.dateIntervalTotalUsers = date;
					this.pieTotals = pieTotals;
				})
				.catch((error) => {
					console.log(error);
				});
		},

		async getVisitorsType(value) {
			await ecAxios
				.connection()
				.post(`${process.env.VUE_APP_API_ADM_EC}/analytics/stats/total-users`, {
					dataInicio:
						value === undefined ? moment().subtract(1, 'days').format('YYYY-MM-DD') : value,
					dataFim: 'today',
					dimension: 'ga:userType',
				})
				.then((res) => {
					const [type_, stats] = res.data;
					this.userTypeStats = [parseInt(stats[0], 10), parseInt(stats[1], 10)];
					// this.dateInterval = [res.data[0]];
				})
				.catch((error) => {
					console.log(error);
				});
		},

		async getSessions(value) {
			await ecAxios
				.connection()
				.post(`${process.env.VUE_APP_API_ADM_EC}/analytics/stats/sessions`, {
					dataInicio:
						value === undefined ? moment().subtract(1, 'days').format('YYYY-MM-DD') : value,
					dataFim: 'today',
					dimension: '',
				})
				.then((res) => {
					this.sessionsStats = res.data;
					this.dateIntervalSessions = [res.data[0]];
				})
				.catch((error) => {
					console.log(error);
				});
		},

		async getBounceRate(value) {
			await ecAxios
				.connection()
				.post(`${process.env.VUE_APP_API_ADM_EC}/analytics/stats/bounce-rate`, {
					dataInicio:
						value === undefined ? moment().subtract(1, 'days').format('YYYY-MM-DD') : value,
					dataFim: 'today',
					dimension: '',
				})
				.then((res) => {
					res.data[1] = res.data[1].map((item) => item.slice(0, 5));
					res.data[2] = res.data[1].map((item) => `${item.slice(0, 5)}%`);
					this.bounceRateStats = res.data;
					this.dateIntervalBounceRate = [res.data[0]];
				})
				.catch((error) => {
					console.log(error);
				});
		},

		async getAvgSessionDuration(value) {
			await ecAxios
				.connection()
				.post(`${process.env.VUE_APP_API_ADM_EC}/analytics/stats/avg-session-duration`, {
					dataInicio:
						value === undefined ? moment().subtract(1, 'days').format('YYYY-MM-DD') : value,
					dataFim: 'today',
					dimension: '',
				})
				.then((res) => {
					// res.data[1] = res.data[1].map((item) => new Date(item * 1000).toISOString().slice(11, 19));
					res.data[2][0] = new Date(res.data[2][0] * 1000).toISOString().slice(11, 19);
					this.avgSessionDurationStats = res.data;
					this.dateIntervalAvgSessionDuration = [res.data[0]];
				})
				.catch((error) => {
					this.$buefy.notification.open({
						message: error.message || 'Erro ao buscar estatísticas',
						type: 'is-success',
					});
				});
		},

		async getScreenViewsPerPage(value) {
			await ecAxios
				.connection()
				.post(`${process.env.VUE_APP_API_ADM_EC}/analytics/stats/screen-page-views`, {
					dataInicio:
						value === undefined ? moment().subtract(1, 'days').format('YYYY-MM-DD') : value,
					dataFim: 'today',
					dimension: '',
				})
				.then((res) => {
					this.screenViewsPerPageStats = res.data;
					this.dateIntervalScreenViewsPerPage = [res.data[0]];
				})
				.catch((error) => {
					this.$buefy.notification.open({
						message: error.message || 'Erro ao buscar estatísticas',
						type: 'is-success',
					});
				});
		},
	},
};
</script>

<style lang="scss" scoped>
.last-updated {
	display: flex;
	flex-direction: column;
	padding: 15px;

	.title {
		font-size: 12px;
		color: #666666;
		margin-bottom: 5px;
	}

	.text {
		font-size: 12px;
		color: #28c76f;
	}
}

.input-date-picker {
	margin-right: 4px;
}

.select-custom {
	border: 1px solid #e2eaf5;
	border-radius: 4px;
	padding: 4px;
}

.situation-box {
	padding-top: 20px;
	padding-bottom: 15px;
	padding-right: 10px;
	padding-left: 10px;
}

.situation-box-input {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
}

.grouped-situation-input {
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.container-dropdown-item {
	padding: 10px;
	height: 300px;
}

.titulo-pedidos-chart {
	font-size: 16px;
}

.text-margin {
	margin-left: 10px;
}

.text-margin h1 {
	font-size: 12px;
	font-weight: bold;
}

.total-valor {
	font-weight: 400;
	font-size: 14px;
}

.total-finalizados {
	display: flex;
	align-items: center;
	flex-direction: row;
	padding: 15px;
}

.box-pedidos-filtros {
	display: flex;
	padding-top: 30px;
	flex-direction: column;
}

.title-filtro {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
}

.container-valor {
	padding-top: 30px;
	width: 30%;
}

.box-labels {
	display: flex;
	widows: 90%;
}

.label-chart-rectangle {
	display: flex;
	align-items: center;
	justify-content: center;
	margin-left: 12px;
	font-size: 12px;
	font-weight: bold;
	color: #242f48;
}

.title-rectangle {
	display: flex;
	margin-right: 30px;
	justify-content: space-between;
}

.rectangle-chart {
	display: flex;
	flex-direction: row;
	margin-top: 30px;
	width: 67%;
	border-radius: 5px;
	border: 1px solid #deebfd;
	box-shadow: -8px 12px 18px 0 #dadee8;
	max-height: 400px;
	background-color: #fff;
}

.box-rectangle {
	width: 70%;
	height: 100%;
	display: flex;
	flex-direction: column;
	padding-top: 30px;
	padding-left: 30px;
	padding-bottom: 30px;
	border-right: 1px dotted #e2e8f5;
}

.tree-session {
	display: flex;
	width: 100%;
	flex-direction: row;
	justify-content: space-between;
	flex-wrap: wrap;
}

.button {
	all: unset;
	align-items: center;
	display: flex;
	padding-left: 5px;
	padding-right: 5px;
}

.box-map {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	justify-content: space-between;
	margin-top: 15px;
}

.box-states {
	display: flex;
	justify-content: space-between;
	background-color: #2d00f717;
	color: #2d00f5;
	font-weight: bold;
	font-size: 10px;
	padding: 5px;
	border-radius: 5px;
	width: 100%;
}

.device-days {
	font-size: 10px;
}

.map-label {
	display: flex;
	width: 49%;
	margin-bottom: 10px;
	flex-direction: row;
	flex-wrap: wrap;
	justify-content: center;
	cursor: pointer;
	transition: 300ms ease-in-out;
}

.map-label:hover {
	transform: scale(1.05);
}

.map-label.inactive {
	display: none;
}

.map-container {
	margin-top: 30px;
	width: 30%;
	display: flex;
	align-items: center;
	flex-direction: column;
	justify-content: center;
	margin-bottom: 30px;
	background-color: #fff;
	border-radius: 5px;
	border: 1px solid #deebfd;
	box-shadow: -8px 12px 18px 0 #dadee8;
	padding: 30px;
}

.square-container {
	width: calc(25% - 15px);
	display: flex;
	justify-content: space-between;
	flex-direction: column;
	background-color: #fff;
	border-radius: 5px;
	box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1);
}

.second-session {
	width: 100%;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
}

.container-squares-charts {
	width: 100%;
	height: 230px;
	display: flex;
	justify-content: space-between;
	margin-bottom: 20px;
}

.chart-custom {
	width: 66.5%;
	align-items: center;
	justify-content: center;
	background-color: #fff;
	padding: 20px;
	border-radius: 5px;
	border: 1px solid #deebfd;
	box-shadow: -8px 12px 18px 0 #dadee8;
}

.legend-chart {
	display: flex;
}

.legend-chart h1 {
	margin-right: 10px;
	font-size: 10px;
}

.data-picker {
	width: 10px;
	height: 10px;
}

.container-analytics {
	min-height: 100vh;
}

.nav-chart-top {
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	box-sizing: border-box;
	padding-left: 22px;
	padding-right: 22px;
}

.chart-description {
	padding-left: 22px;
	padding-right: 22px;
}

.nav-chart-top h1 {
	font-size: 16px;
}

.box-last-sales {
	overflow: auto;
	padding: 40px;
	background-color: #fff;
	margin-top: 24px;
	margin-bottom: 200px;
}

.title-last-sales {
	font-size: 16px;
	color: #4a4a4a;
	margin-bottom: 40px;
	display: flex;
	align-items: center;
}

.last-sales-icon {
	margin-right: 10px;
	color: #2d00f7;
}

//Analytics Stats
.fourth-session {
	justify-content: space-between;
	margin-bottom: calc(21px + 6rem);
	margin-top: -25px;
	flex-wrap: wrap;
}

.fourth-session #first-block,
.fourth-session #second-block {
	display: flex;
	gap: 30px;
}

#card {
	width: 50%;
	display: flex;
}

.two-blocks {
	margin-top: calc(20px - 18%);
	display: flex;
	margin-left: 33.3%;
	gap: 30px;
	top: 0;
	margin-bottom: 30px;
	justify-content: space-between;
	width: 100%;
}

@media (min-width: 3000px) {
	.two-blocks {
		margin-top: 8rem;
		display: flex;
		margin-left: 33%;
		flex-basis: 100%;
		width: 100%;
		top: 0;
		margin-bottom: 30px;
	}
}

/*.analytics-block {
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	box-sizing: border-box;
	flex-wrap: wrap;
	width: 32%;
	padding-bottom: 0;
}

.two-blocks .analytics-block {
	display: flex;
	align-items: flex-start;
	justify-content: center;
	box-sizing: border-box;
	flex-wrap: wrap;
	padding-bottom: 0;
	width: 48.4%;
}

@media(min-width: 3000px) {
	.two-blocks {
		margin-top: 8rem;
		display: flex;
		margin-left: 33%;
		flex-basis: 100%;
		width: 100%;
		top: 0;
		margin-bottom: 30px;
	}
}

.two-blocks .analytics-block .analytics-chart {
	width: 100%;
}

.analytics-block .analytics-chart {
	width: 99%;
}

@media(min-width: 3000px) {
	.analytics-block .analytics-chart {
		width: 98%;
	}
}

.analytics-chart-pie {
	width: 100%;
	justify-content: center;
	align-items: center;
	height: 14.5rem;
}

.pizza-chart {
	display: flex;
	width: 65%;
	height: 20rem;
	margin-top: 33px;
	background-color: #fff;
	border-radius: 5px;
	border: 1px solid #deebfd;
	box-shadow: -8px 12px 18px 0 #dadee8;
}

.pizza-chart h1 {
	font-size: 16px;
} */
</style>

